export const blockIconsPlacesFitnessCenter = (
	<span className='material-symbols-outlined'>fitness_center</span>
);
